import { Component } from '@angular/core';
import { IonicPage, Events, ViewController, NavController, NavParams } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { RegisterPage } from '../register/register';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { CguPage } from '../cgu/cgu';

/**
 * Generated class for the InfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login-modal',
  templateUrl: 'login-modal.html',
})
export class LoginModalPage {
  errorMessage: string = '';

  constructor(
    public viewCtrl: ViewController,
    public authProvider: AuthProvider,
    public events: Events,
    public navCtrl: NavController,
    public navParams: NavParams) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CardSelectorPage');
  }
  emailRegister(){
    this.navCtrl.push(RegisterPage);
  }
  loginButton(){
    this.navCtrl.push(LoginPage);
  }
  goToCGU(){
    this.navCtrl.push(CguPage);
  }
  dismiss(){
   this.viewCtrl.dismiss(null);
  }

  tryFacebookLogin(){
    this.authProvider.doFacebookLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryGoogleLogin(){
    this.authProvider.doGoogleLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryTwitterLogin(){
    this.authProvider.doTwitterLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-modal/login-modal.ts